<div matDialogTitle>Ett fel har inträffat.</div>
<mat-dialog-content style="overflow: hidden">
  {{ data.text }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton="filled" matDialogClose>Stäng</button>
</mat-dialog-actions>
